import apiRoutes from "./apiRoutes";
import { BaseCrudService } from "./baseCrudService";
import { AxiosResponse } from "axios";
import {
  CertificateVerificationInputData,
  CertificateVerificationRequestData,
  CertificateVerificationResponseData,
} from "../models/CertificateQRCodeVerificationData";

/**
 * The Certificate qrcode verification service.
 */
export class CertificateQRCodeVerificationService extends BaseCrudService {
  /**
   * Verifies a certificate QR code token.
   *
   * @param token - Optional token to verify
   * @returns Response from the verification endpoint.
   */
  async verifyCertificateQRCodeToken(token?: string) {
    const response = await this.get(
      apiRoutes.certificate_qrcode_verification,
      token ?? "",
      { suppressSnackbars: true }
    );
    return response.data;
  }

  /**
   * Tries to retrieve verified certificate data using a token and input data.
   *
   * @param token - Verification token
   * @param inputCertificateData - User-provided certificate input
   * @returns Verified certificate data, or null if verification fails
   */
  async retrieveVerifiedCertificateData(
    token: string,
    inputCertificateData: CertificateVerificationInputData
  ): Promise<CertificateVerificationResponseData | null> {
    const data = {
      token: token,
      last_name_letters: inputCertificateData.last_name_letters,
      year_of_birth: inputCertificateData.year_of_birth,
    };
    try {
      const response = await this.create<
        CertificateVerificationRequestData,
        AxiosResponse<CertificateVerificationResponseData>
      >(apiRoutes.certificate_verification, data, undefined, {
        suppressSnackbars: true,
      });
      return response.data;
    } catch (e) {
      return null;
    }
  }
}
